import { render, staticRenderFns } from "./PieCharts.vue?vue&type=template&id=3fc2c519&scoped=true&"
import script from "./PieCharts.vue?vue&type=script&lang=js&"
export * from "./PieCharts.vue?vue&type=script&lang=js&"
import style0 from "./PieCharts.vue?vue&type=style&index=0&id=3fc2c519&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2c519",
  null
  
)

export default component.exports